import React from 'react';
import ReactDOM from 'react-dom';
import {applyMiddleware, combineReducers, createStore} from 'redux';
import {Provider} from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import {Route} from 'react-router';
import {ConnectedRouter, routerMiddleware, routerReducer} from 'react-router-redux';
import logger from 'redux-logger';
import registerServiceWorker from './registerServiceWorker';
import App from './views/App';
import Widget from './views/Widget';
// import RequireAuth from './views/components/hoc/RequireAuth';
// import NotRequireAuth from './views/components/hoc/NotRequireAuth.js';
// import Signin from './views/components/auth/Signin';
// import Register from './views/components/auth/Register';
import * as reducers from './reducers';
import './index.css';
// import {verifyAuthentication} from "./actions/AuthActions";

const history = createHistory();
const middleware = routerMiddleware(history)
const store = createStore(
    combineReducers({
        ...reducers,
        router: routerReducer
    }),
    applyMiddleware(middleware, logger)
);

// const token = localStorage.getItem('token');
// if (token) {
//     store.dispatch(verifyAuthentication({
//         token
//     }, store.dispatch));
// }

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <Route exact path="/" component={App}/>
                <Route path="/widget" component={Widget}/>
                {/*<Route path="/signin" component={NotRequireAuth(Signin)}/>*/}
                {/*<Route path="/register" component={NotRequireAuth(Register)}/>*/}
            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js